module.exports = __webpack_public_path__ + "img/fon-welcome.a00643ab.png";